import { FileKind } from "../../../../define/FileKind";
import { BaseLocalListData } from "../../base/BaseLocalListData";

/** 城市数据 */
class NewCityData{
    /** 城市唯一id */
    id: string = '';
    /** 当前镇守的武将id */
    officerId: string = '';
    
}

export default class MilitaryNewCityListData extends BaseLocalListData {
    lists = new Map<string, NewCityData>();

    protected localKey: string = FileKind.SaveLocalDataKey.MILITARY_NEW_CITY_DATA;

    /** 是否接收过补偿 */
    bRecvCompensate: boolean = false;

    createItem(key: string): NewCityData {
        return this.createItemT<NewCityData>(NewCityData, key);
    }
}
